<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Тавтай морил</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Голомтын соёл, гоёл</li>
            </ol>
          </nav>


          <div class="row">
            <div v-for="(t, ti) in tasks" class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div @click="showVid(t)" role="button" class="">
                <div class="overflow-hidden w-full rounded-10 mg-b-10 pos-relative ht-200"
                :style="`background-image: url(${t.secondAttachmentUrl}); background-size: cover; background-repeat: no-repeat`">
                  <!-- <img src="https://img.youtube.com/vi/2f89d1vlyVo/maxresdefault.jpg" class="w-full rounded-10 ht-200" /> -->
                  <div class="pos-absolute r-10 b-10 tx-semibold bg-primary pd-x-4 rounded tx-white">{{ frmtMin(t.i1) }}</div>  
                </div>
                <div class="tx-semibold">{{ t.task }}</div>
                <div>{{ t.user.fullName }}</div>
                <div class="d-flex">
                  <div>{{ t.viewCount }} үзсэн</div>
                  <div><feather type="more-vertical" style="height: 9px"></feather></div>
                  <div>{{ frmtAgo(t.createdDate) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>
    <b-modal v-model="task.mdl" centered hide-footer hide-header size="lg">
    <!-- {{ task.defaultAttachmentUrl }} -->
      <video width="100%" controls controlslist="nodownload" autoplay>
          <source
            :src="task.obj.defaultAttachmentUrl"
            type="video/mp4"
          />
          Your browser does not support HTML5 video.
        </video>
      <!-- <file-preview :minusHeight="400" :show="task.rdy" :id.sync="task.obj.defaultAttachmentId" @on-hide="task.mdl = false" :force="true" /> -->
      <!-- <iframe width="100%" height="460" src="https://www.youtube.com/embed/2f89d1vlyVo?si=VWxmLlE4KAO2gJZv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import Masonry from "masonry-layout"

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      task:{
        mdl: false,
        rdy: false,
        obj:{}
      },
      curInd: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      tasks: []
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    frmtMin(min){
      const hours = Math.floor(min / 60);
      const remainingMinutes = min % 60;
      return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
    },
    frmtAgo(dt){
      let rv= null;
      rv= moment(dt).fromNow()
      return rv;
    },
    showVid(task){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/TaskInheritedDetail" },
        params: { id: task.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.task.obj= res.data.task;
          this.task.rdy= true;
          this.task.mdl= true;
        }
      });
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 611
      );
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 200,
            model: {
              isPublic: true
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.tasks= res.data.tasks;
          }
        });
      }
    },
    
  },
};
</script>